import { render } from "./ec2Summary.vue?vue&type=template&id=24d7d842"
import script from "./ec2Summary.vue?vue&type=script&lang=js"
export * from "./ec2Summary.vue?vue&type=script&lang=js"

import "./ec2Summary.vue?vue&type=style&index=0&id=24d7d842&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__